import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.75C0 1.67893 1.67893 0 3.75 0H26.25C28.3211 0 30 1.67893 30 3.75V26.25C30 28.3211 28.3211 30 26.25 30H3.75C1.67893 30 0 28.3211 0 26.25V3.75Z"
      fill="#38D695"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5124 5.62134C11.1384 5.62134 10.8353 5.92448 10.8353 6.29842V7.42821H12.1895V6.9755H18.1049V7.42821H19.4591V6.29842C19.4591 5.92448 19.1559 5.62134 18.782 5.62134H11.5124ZM8.41213 9.68778C8.41213 9.31384 8.71527 9.0107 9.08921 9.0107H21.2053C21.5792 9.0107 21.8823 9.31384 21.8823 9.68778V10.8176H20.5282V10.3649H9.7663V10.8176H8.41213V9.68778ZM6.66602 22.9668V13.3555C6.66602 12.9821 6.82884 12.6239 7.11868 12.3598C7.40852 12.0957 7.80162 11.9473 8.21152 11.9473H21.7872C22.1971 11.9473 22.5902 12.0957 22.88 12.3598C23.1699 12.6239 23.3327 12.9821 23.3327 13.3555V22.9668C23.3327 23.3403 23.1699 23.6984 22.88 23.9625C22.5902 24.2266 22.1971 24.375 21.7872 24.375H8.21152C7.80162 24.375 7.40852 24.2266 7.11868 23.9625C6.82884 23.6984 6.66602 23.3403 6.66602 22.9668ZM21.7872 14.7637H14.0072H8.21152V22.9668H21.7872V14.7637Z"
      fill="white"
    />
  </svg>
);
const SvgPlaybook = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPlaybook;
